import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { cn } from '@/lib/utils';
export interface PageSectionProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  /** Mono note aligned right of the title: counts, ranges, units. */
  meta?: React.ReactNode;
  title: React.ReactNode;
}

/** A bordered block of the page, titled in serif with an optional mono note. */
export const PageSection = t0 => {
  const $ = _c(20);
  const {
    children,
    className,
    contentClassName,
    meta,
    title
  } = t0;
  const titleId = useId();
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-4 rounded-md border border-border bg-card px-6 pt-[22px] pb-[26px]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title || $[3] !== titleId) {
    t2 = <h2 id={titleId} className="m-0 font-serif text-[26px] leading-none font-medium">{title}</h2>;
    $[2] = title;
    $[3] = titleId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== meta) {
    t3 = meta ? <span className="font-mono text-[12.5px] text-muted-foreground">{meta}</span> : null;
    $[5] = meta;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-wrap items-baseline justify-between gap-2">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== contentClassName) {
    t5 = cn("flex flex-col gap-4", contentClassName);
    $[10] = contentClassName;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[12] = children;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t4 || $[17] !== t6 || $[18] !== titleId) {
    t7 = <section aria-labelledby={titleId} className={t1}>{t4}{t6}</section>;
    $[15] = t1;
    $[16] = t4;
    $[17] = t6;
    $[18] = titleId;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};